module.exports = __webpack_public_path__ + "static/media/other_tools_es.cbf26c73.png";